import { BaseRecord, CreateResponse } from "@refinedev/core";

export async function manualRetryApi({
  cb,
  maxRetries = 3,
  delay = 100,
}: {
  cb: () => Promise<CreateResponse<BaseRecord>>;
  maxRetries?: number;
  delay?: number;
}) {
  let attempt = 0;

  while (attempt < maxRetries) {
    try {
      const response = await cb();

      return response;
    } catch (error: any) {
      const status = error?.response?.status;
      const message = error?.message;
      const code = error?.code;

      if (status === 502 || code === "ECONNABORTED" || message === "Network Error") {
        attempt++;
        console.warn(`⚠️ Retry attempt ${attempt}/${maxRetries} due to timeout or 502`);
        await new Promise((res) => setTimeout(res, delay));
      } else {
        console.error("⛔️ Stopping retry, unexpected error:", error);
        throw error;
      }
    }
  }

  throw new Error("API call failed after multiple retry attempts due to 502 errors.");
}
